import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const BaseSwal = withReactContent(Swal);

const ReactSwal = BaseSwal.mixin({
  buttonsStyling: false,
  showCloseButton: true,
  customClass: {
    confirmButton: 'btn btn-primary btn-lg',
    cancelButton: 'btn btn-default btn-lg',
    actions: 'text-center',
  },
});

export default ReactSwal;
